module.exports = __webpack_public_path__ + "img/jhsys2.add6765d.png";